import React, { useState, useEffect } from "react";
import {
  Col, Modal, ModalBody, ModalFooter, ModalHeader,
  Label, Input, Row
} from "reactstrap";

import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import {
  createSpecValue,
  getSpecValueById,
  updateSpecValue,
  deleteSpecValue,
  listSpecValueByParams,
  specTypeDropdown
} from "../../api/specValue.api";

const initialState = {
  product_id: "",
  spec_id: "",
  spec_value: ""
};

const SpecValuesMaster = () => {

  const [values, setValues] = useState(initialState);
  const [data, setData] = useState([]);
  const [specTypes, setSpecTypes] = useState([]);

  const [query, setQuery] = useState("");

  const [modal_add, setModalAdd] = useState(false);
  const [modal_edit, setModalEdit] = useState(false);
  const [modal_delete, setModalDelete] = useState(false);

  const [_id, set_Id] = useState("");
  const [remove_id, setRemove_id] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [totalRows, setTotalRows] = useState(0);



  const fetchDropdown = async () => {
    const res = await specTypeDropdown();
    setSpecTypes(res.data.data || []);
  };



  const fetchData = async () => {

    const skip = (pageNo - 1) * perPage;

    const res = await listSpecValueByParams({
      skip,
      per_page: perPage,
      match: query
    });

    if (res.data.data.length > 0) {

      const result = res.data.data[0];

      setData(result.data);
      setTotalRows(result.count);

    } else {
      setData([]);
    }

  };



  useEffect(() => {
    fetchDropdown();
    fetchData();
  }, [query, pageNo, perPage]);



  const handleChange = (e) =>
    setValues({ ...values, [e.target.name]: e.target.value });



  const handleCreate = async (e) => {

    e.preventDefault();

    await createSpecValue(values);

    toast.success("Spec Value Added");

    setModalAdd(false);
    setValues(initialState);

    fetchData();

  };



  const handleEdit = (id) => {

    set_Id(id);

    getSpecValueById(id).then(res => {

      setValues(res.data.data);
      setModalEdit(true);

    });

  };



  const handleUpdate = async (e) => {

    e.preventDefault();

    await updateSpecValue(_id, values);

    toast.success("Updated");

    setModalEdit(false);
    setValues(initialState);

    fetchData();

  };



  const handleDelete = async () => {

    await deleteSpecValue(remove_id);

    toast.success("Deleted");

    setModalDelete(false);

    fetchData();

  };



  const customStyles = {
    headRow: { style: { borderBottom: "2px solid #f3f4f6" } },
    headCells: {
      style: {
        color: "#6b7280",
        fontWeight: "700",
        textTransform: "uppercase",
        fontSize: "11px",
        letterSpacing: "0.5px"
      }
    },
    cells: { style: { fontSize: "14px", color: "#374151", padding: "15px 10px" } },
  };



  const columns = [

    { name: "Sr No", selector: (r, i) => i + 1, width: "70px" },

    { name: "Family", selector: r => r.family_name, grow: 1 },

    { name: "Spec Type", selector: r => r.spec_label, grow: 1, style: { color: "#6b7280" } },

    { name: "Value", selector: r => r.value, grow: 2, style: { fontWeight: "600" } },

    {
      name: "Actions",
      right: true,
      cell: (row) => (
        <div className="d-flex gap-3">

          <button
            className="btn btn-link p-0 text-muted"
            onClick={() => handleEdit(row.id)}
          >
            🖊️
          </button>

          <button
            className="btn btn-link p-0 text-danger"
            onClick={() => {
              setRemove_id(row.id);
              setModalDelete(true);
            }}
          >
            🗑️
          </button>

        </div>
      )
    }

  ];



  return (

    <div style={{ backgroundColor: "#ffffff", padding:"clamp(15px, 3vw, 24px)",borderRadius:"12px",border:"1px solid #e5e7eb" }}>

      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

        <div>
          <h4 className="fw-bold m-0" style={{ color: "#112347" }}>Specification Values</h4>
          <p className="text-muted small m-0">Manage specific technical values and attributes for product families</p>
        </div>

        <button
          className="btn btn-dark fw-bold px-4 py-2"
          style={{ backgroundColor: "#112347", borderRadius: "8px", border: "none" }}
          onClick={() => {
            setValues(initialState);
            setModalAdd(true);
          }}
        >
          + Add Spec Value
        </button>

      </div>



      <Row className="mb-4 g-3">

        <Col xs="12" md="5" className="position-relative">

          <span className="position-absolute translate-middle-y top-50 ms-3 text-muted">🔍</span>

          <Input
            placeholder="Search Values..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", paddingLeft: "40px" }}
          />

        </Col>

      </Row>



      <div className="table-responsive border rounded-3 overflow-hidden">

        <DataTable
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={setPageNo}
          onChangeRowsPerPage={setPerPage}
          customStyles={customStyles}
        />

      </div>



      {/* ADD MODAL */}

      <Modal isOpen={modal_add} toggle={() => setModalAdd(false)} centered>

        <ModalHeader className="border-0 pb-0">Add Spec Value</ModalHeader>

        <ModalBody className="pt-2">

          <Label className="small fw-bold">Spec Type</Label>

          <Input
            type="select"
            name="spec_id"
            value={values.spec_id}
            onChange={handleChange}
            className="mb-3"
          >
            <option value="">Select Spec Type</option>
            {specTypes.map(s => (
              <option key={s.id} value={s.id}>
                {s.spec_label}
              </option>
            ))}
          </Input>

          <Label className="small fw-bold">Value</Label>

          <Input
            name="spec_value"
            value={values.spec_value}
            onChange={handleChange}
            placeholder="e.g. 5000 kg or Pneumatic"
          />

        </ModalBody>

        <ModalFooter className="border-0">

          <button
            className="btn btn-dark w-100 py-2 fw-bold"
            onClick={handleCreate}
            style={{ backgroundColor: "#112347" }}
          >
            Save Spec Value
          </button>

        </ModalFooter>

      </Modal>



      {/* EDIT MODAL */}

      <Modal isOpen={modal_edit} toggle={() => setModalEdit(false)} centered>

        <ModalHeader className="border-0 pb-0">Edit Spec Value</ModalHeader>

        <ModalBody>

          <Label className="small fw-bold">Spec Type</Label>

          <Input
            type="select"
            name="spec_id"
            value={values.spec_id}
            onChange={handleChange}
            className="mb-3"
          >
            {specTypes.map(s => (
              <option key={s.id} value={s.id}>
                {s.spec_label}
              </option>
            ))}
          </Input>

          <Label className="small fw-bold">Value</Label>

          <Input
            name="spec_value"
            value={values.spec_value}
            onChange={handleChange}
          />

        </ModalBody>

        <ModalFooter className="border-0">

          <button
            className="btn btn-success w-100 py-2 fw-bold"
            onClick={handleUpdate}
          >
            Update Changes
          </button>

        </ModalFooter>

      </Modal>



      {/* DELETE MODAL */}

      <Modal isOpen={modal_delete} toggle={() => setModalDelete(false)} centered>

        <ModalBody className="text-center py-4">

          <h5 className="fw-bold">Confirm Delete</h5>

          <p className="text-muted">
            Are you sure you want to remove this specification value?
          </p>

          <div className="d-flex gap-2 justify-content-center mt-4">

            <button
              className="btn btn-light px-4"
              onClick={() => setModalDelete(false)}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDelete}
            >
              Delete
            </button>

          </div>

        </ModalBody>

      </Modal>

    </div>

  );

};

export default SpecValuesMaster;